
import { Badge } from "@/components/ui/badge";

interface CallStatusBadgeProps {
  status: string;
}

export const CallStatusBadge = ({ status }: CallStatusBadgeProps) => {
  // Fixed the variant issue by only using available variants from badge.tsx
  let variant: "default" | "destructive" | "secondary" | "outline" | "success" = "default";
  
  switch (status) {
    case "completed":
      variant = "success";
      break;
    case "in-progress":
      variant = "secondary"; // Using secondary instead of warning since warning isn't in the badge variants
      break;
    case "queued":
      variant = "outline";
      break;
    case "reactivated":
      variant = "success";
      break;
    case "failed":
      variant = "destructive";
      break;
    case "not-interested":
      variant = "destructive";
      break;
    default:
      variant = "default";
  }
  
  // Format the status text to be more user-friendly
  const getDisplayText = () => {
    switch (status) {
      case "in-progress":
        return "In Progress";
      case "not-interested":
        return "Not Interested";
      default:
        // Capitalize first letter
        return status.charAt(0).toUpperCase() + status.slice(1);
    }
  };
  
  return <Badge variant={variant}>{getDisplayText()}</Badge>;
};
